import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { ThemeProvider } from '@hooks/useTheme'
import { AnnouncerProvider, SkipLink } from '@components/ui'
import '@styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark">
      <AnnouncerProvider>
        <SkipLink targetId="main-content" />
        <RouterProvider router={router} />
      </AnnouncerProvider>
    </ThemeProvider>
  </React.StrictMode>
)
